export const SearchFailedModalConstants = {
    searchFailedModalTitle: 'Search Failed',
    searchFailedModalContent:
        'Your search failed. Please review your inputs and try again. If the problem persists, please contact EWA.',
    searchFailedModalPrimaryAction: 'OK',
} as const;
